"use strict"; // TODO: Add copyright blurb

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.authorizedHTTP = exports.apiRoot = void 0; // The HTTP.ts root holds general setup of the http module

var axios_1 = __importDefault(require("axios"));

var axios_rate_limit_1 = __importDefault(require("axios-rate-limit"));

var maxRPS = 5;
exports.apiRoot = "https://api.comsel.net";
var http = axios_rate_limit_1.default(axios_1.default.create({
  baseURL: exports.apiRoot
}), {
  maxRequests: maxRPS,
  perMilliseconds: 1000
});

exports.authorizedHTTP = function (credentials) {
  var headers = {
    'Authorization': 'Bearer ' + credentials.token()
  };

  if (credentials.userAgent().length > 0) {
    headers['User-Agent'] = credentials.userAgent();
  }

  if (credentials.referer().length > 0) {
    headers['Referer'] = credentials.referer();
  }

  return axios_rate_limit_1.default(axios_1.default.create({
    baseURL: exports.apiRoot,
    headers: headers
  }), {
    maxRequests: maxRPS,
    perMilliseconds: 1000
  });
};

exports.default = http;